//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

import { GalleriesPickerActionType } from '@galleries/actions/galleriesPickerActions';
import { GALLERIES_ACTIONS } from '@galleries/constants/galleriesConstants';
import { IGalleriesPicker } from '@galleries/models/galleriesStateModel';
import GalleryContainerId from '@galleries/models/GalleryContainerId';

const initialState: IGalleriesPicker = {
  selectedGalleryId: GalleryContainerId(''), // TODO: Can this be undefined or null instead?
};

export default function GalleriesPickerReducer(
  state: IGalleriesPicker = initialState,
  action: GalleriesPickerActionType,
): IGalleriesPicker {
  switch (action.type) {
    case GALLERIES_ACTIONS.SELECT_GALLERY: {
      return {
        ...state,
        selectedGalleryId: action.selectedGalleryId,
      };
    }

    default:
      return state;
  }
}
